import { render, staticRenderFns } from "./QRcodes.vue?vue&type=template&id=cbfe16a8"
import script from "./QRcodes.vue?vue&type=script&lang=js"
export * from "./QRcodes.vue?vue&type=script&lang=js"
import style0 from "./QRcodes.vue?vue&type=style&index=0&id=cbfe16a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports